<template>
<div class="container">
	<img src="../../images/pd.png" alt="" style="width:100%;margin-top:-3rem;">
</div>
</template>

<style scoped>
	
</style>

<script>

export default {
	data:function(){
		return {
			info:""
		}
	}
}	
</script>


// WEBPACK FOOTER //
// src/components/other/pd.vue